
var hoverElements = document.getElementsByClassName('hover-effect');

for (var i = 0; i < hoverElements.length; i++) {
    var hoverElement = hoverElements[i];
    hoverElement.addEventListener('mouseover', function () {
        this.classList.add('hovered');
    });

    hoverElement.addEventListener('mouseout', function () {
        this.classList.remove('hovered');
    });
}


// WEBPACK FOOTER //
// ./Components/Shared/hover.js